import { ConfigurationRepositoryConfigurationCommandsService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryConfigurationCommandsService'
import { useMutation } from '@tanstack/react-query'

type InputArguments = {
  branchName: string
  server: string
}

export const useRebaseBranch = () =>
  useMutation({
    mutationFn: async ({ branchName, server }: InputArguments) => {
      await ConfigurationRepositoryConfigurationCommandsService.configurationCommandServicePostRebaseBranch(
        {
          requestBody: {
            _type: 'RebaseBranchSpecification',
            branchName,
            componentName: server.toLocaleLowerCase(),
          },
        },
      )
    },
  })
